import Vue from 'vue'
import VueRouter from 'vue-router'
import Surveylist from '../views/survey/Surveylist.vue'
import Questionlist from '../views/question/Questionlist.vue'
import DisplaySide from '../views/DisplaySide.vue'
import Overview from '../views/dashboard/Overview.vue'
import MultiselectFlow from '../views/webform/MultiselectFlow.vue'
import QuestionSummary from '../views/dashboard/QuestionSummary.vue'
import StepForms from '../views/webform/StepFormsConfig.vue'
import StepEnd from '../views/webform/StepEndConfig.vue'
import FormAuth from '../views/webform/FormAuth.vue'
import OneIDValidate from '../views/webform/Auth_stage/OneIDValidate.vue'
import Setting from '../views/setting/Setting.vue'
import Role from '../views/role/Role.vue'
import Permission from '../views/permission/Permission.vue'
import FormConfig from '../views/webform/FormConfig.vue'
import Register from '../views/auth/Register.vue';
import Terms from '../components/Policy/termsCon.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'survey',
    component: Surveylist
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms
  },
  {
    path: '/multiselect',
    name: 'multiselect',
    component: MultiselectFlow
  },
  {
    path: '/startform',
    name: 'startform',
    component: FormAuth
  },
  {
    path: '/startform/oneid_validate',
    name: 'oneid_validate',
    component: OneIDValidate
  },
  {
    path: '/webform',
    name: 'webform',
    component: StepForms
  },
  {
    path: '/webform/end',
    name: 'endwebform',
    component: StepEnd
  },
  {
    path: '/:surveyID-@:surveyName/',
    component: DisplaySide,
    children: [
      {
        path: '/:surveyID-@:surveyName/question',
        name: 'question',
        component: Questionlist,
      },
      {
        path: '/:surveyID-@:surveyName/dashboard/overview',
        name: 'overview',
        component: Overview,
      },
      {
        path: '/:surveyID-@:surveyName/dashboard/question',
        name: 'questionsummary',
        component: QuestionSummary,
      },
      {
        path: '/:surveyID-@:surveyName/setting',
        name: 'setting',
        component: Setting,
      },
      {
        path: '/:surveyID-@:surveyName/role',
        name: 'role',
        component: Role,
      },
      {
        path: '/:surveyID-@:surveyName/permission',
        name: 'permission',
        component: Permission,
      },
      {
        path: '/:surveyID-@:surveyName/form/config',
        name: 'formconfig',
        component: FormConfig,
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
